(function () {
    'use strict';

    angular.module("imApp").factory("poFinishProdCompsBsService", ['$ihttp', function ($ihttp) {
        let service = {
            listPoFinishProdCompsBs: function (parms) {
                return $ihttp.post({
                    method: 172,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
